module.exports = {"width":302,"height":202,"type":"png"}